export enum ServiceNames {
	SAVINGS = "SavingsService",
	USER = "UserService",
	PROFILE = "ProfileService",
	FIAT = "FiatService",
	FIAT_WALLET = "FiatWalletService",
	METAL_WALLET = "MetalWalletService",
	CRYPTO_WALLET = "CryptoWalletService",
	INDEX_WALLET = "IndexWalletService",
	ETF_WALLET = "EtfWalletService",
	ETC_WALLET = "EtcWalletService",
	LEVERAGED_TOKEN_WALLET = "LeveragedTokenWalletService",
	SECURITY_TOKEN_WALLET = "SecurityTokenWalletService",
	FIAT_EARN = "FiatEarnService",
	STOCK_WALLET = "StockWalletService",
	CONTACT = "ContactService",
	PAY_ACCOUNT = "PayaccountService",
	MEMBERS_DATA = "MembersDataService",
	MASTER_DATA = "MasterdataService",
	TRADABLE_LIST = "TradableListService",
	TRADABLE_WALLET_LIST = "TradableWalletListService",
	PRICE_ALERT = "PriceAlertService",
	ONFIDO = "OnfidoService",
	FEATURED_ASSETS = "FeaturedAssetsService",
	SECURITY = "SecurityService",
	INIT_ASSETS_SERVICE = "InitAssetsService",
	CORE_STORE = "CoreStoreStateService",
	ASSET_WALLET = "AssetWalletService",
	STATSIG = "Statsig"
}
